import { useTranslation } from 'i18n';
import type { ComponentProps } from 'react';
import { PriceChip, Skeleton, Typography } from 'ui';

type Props = {
  isLoading?: boolean;
  guidePrice?: string;
} & Omit<ComponentProps<typeof PriceChip>, 'children'>;

export const GuidePriceChip = ({ guidePrice, isLoading, ...rest }: Props) => {
  const { t } = useTranslation('features');

  if (isLoading) {
    return (
      <Skeleton
        data-testid="guide-price-loader"
        variant="rounded"
        sx={{
          width: '100%',
          height: 50,
        }}
      />
    );
  }

  if (!guidePrice) {
    return (
      <PriceChip {...rest}>
        <Typography
          data-testid="guide-price-unavailable"
          variant="caption"
          color="secondary"
          sx={{
            display: 'block',
          }}
        >
          {t('backlog.guidePriceChip.unavailable')}
        </Typography>
      </PriceChip>
    );
  }
  return (
    <PriceChip {...rest}>
      <Typography
        variant="inherit"
        component="span"
        sx={{
          whiteSpace: 'nowrap',
          display: 'block',
        }}
      >
        {guidePrice}
      </Typography>
      <Typography
        variant="caption"
        color="secondary"
        sx={{
          display: 'block',
        }}
      >
        {t('backlog.guidePriceChip.label')}
      </Typography>
    </PriceChip>
  );
};
